//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UserDetail from '@/components/System/User/UserDetail';
export default {
  components: {
    UserDetail: UserDetail
  },
  data: function data() {
    return {
      formInline: {
        user: '',
        region: ''
      }
    };
  },
  methods: {
    syncFn: function syncFn() {},
    searchFn: function searchFn() {}
  }
};